/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_change_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. A negative percentage change means the value decreased; a positive value means it increased.`)
};

const es_pct_change_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Un cambio porcentual negativo significa que el valor disminuyó; uno positivo significa que aumentó.`)
};

const de_pct_change_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Eine negative prozentuale Veränderung bedeutet, dass der Wert gesunken ist; ein positiver Wert bedeutet, dass er gestiegen ist.`)
};

const nl_pct_change_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Een negatieve percentageverandering betekent dat de waarde is gedaald; een positieve waarde betekent dat hij is gestegen.`)
};

const fr_pct_change_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Une variation en pourcentage négative signifie que la valeur a diminué ; une valeur positive signifie qu'elle a augmenté.`)
};

const it_pct_change_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Una variazione percentuale negativa significa che il valore è diminuito; un valore positivo significa che è aumentato.`)
};

const pt_br2_pct_change_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Uma variação percentual negativa significa que o valor diminuiu; um valor positivo significa que ele aumentou.`)
};

const pt_pct_change_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Uma variação percentual negativa significa que o valor diminuiu; um valor positivo significa que aumentou.`)
};

const ja_pct_change_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。パーセント変化がマイナスの場合は値が減少したことを、プラスの場合は増加したことを意味します。`)
};

const zh_pct_change_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。负的百分比变化表示数值下降；正值表示数值上升。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_change_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_change_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_change_faq2_a", locale)
	if (locale === "en") return en_pct_change_faq2_a(inputs)
	if (locale === "es") return es_pct_change_faq2_a(inputs)
	if (locale === "de") return de_pct_change_faq2_a(inputs)
	if (locale === "nl") return nl_pct_change_faq2_a(inputs)
	if (locale === "fr") return fr_pct_change_faq2_a(inputs)
	if (locale === "it") return it_pct_change_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_change_faq2_a(inputs)
	if (locale === "pt") return pt_pct_change_faq2_a(inputs)
	if (locale === "ja") return ja_pct_change_faq2_a(inputs)
	return zh_pct_change_faq2_a(inputs)
};